import * as DialogContract from '@tableau/hybrid-widgets-contract';
import * as React from 'react';
import * as widgets from '@tableau/widgets';

const ResizeModeGlue: { [key in DialogContract.DialogUserResizeMode]: widgets.DialogUserResizeMode } = Object.freeze({
  [DialogContract.DialogUserResizeMode.NotResizable]: widgets.DialogUserResizeMode.NotResizable,
  [DialogContract.DialogUserResizeMode.Horizontal]: widgets.DialogUserResizeMode.Horizontal,
  [DialogContract.DialogUserResizeMode.Vertical]: widgets.DialogUserResizeMode.Vertical,
  [DialogContract.DialogUserResizeMode.Both]: widgets.DialogUserResizeMode.Both,
});

const dialogTitleHeight = 30;

/**
 * @param height is deprecated and thus its value gets ignored when contentHeight is defined
 * @param contentHeight dialog content height without title bar height
 * @returns value for the `widgets.DialogWidget` height props
 */
const getHeight = (height?: number, contentHeight?: number): number | undefined => {
  if (contentHeight !== undefined) {
    return contentHeight + dialogTitleHeight;
  } else if (height !== undefined) {
    return height + dialogTitleHeight;
  } else {
    return undefined;
  }
};

export class DialogContractWidget
  extends React.Component<DialogContract.DialogContractProps, {}>
  implements DialogContract.DialogContractWidget {
  public componentDidMount(): void {
    if (this.props.onShowCompleted) {
      this.props.onShowCompleted();
    }
  }
  public render(): JSX.Element {
    const { pos } = this.props;
    const userResizeMode =
      ResizeModeGlue[this.props.userResizeMode || DialogContract.DialogUserResizeMode.NotResizable];
    const initialPosition = pos ? { top: Math.round(pos.y), left: Math.round(pos.x) } : undefined;

    // this props are deleted from the contract as of 6.0.0, but pull them out just in case they're still present at runtime
    const { dialogHeight, dialogMinHeight } = (this.props as unknown as { [key: string]: number | undefined });

    const dialogProps: widgets.DialogProps = {
      children: this.props.children,
      // Set overflow: 'visible' to explicitly disable scroll bar for hybrid dialogs.
      // As the dialog resizes on desktop there's a bit of lag between chrome and the actual web render.
      // The result is that the scroll bar would flicker in and out of existence on desktop whenever you
      // resized something. So scroll bar is disabled on the desktop side, and it should be disabled here
      // for web version to keep hybrid dialog appearances consistent on both sides.
      dialogBodyStyle: { ...this.props.dialogBodyStyle, overflow: 'visible' },
      dialogHeight: getHeight(dialogHeight, this.props.dialogContentHeight),
      dialogMinHeight: getHeight(dialogMinHeight, this.props.dialogContentMinHeight),
      dialogMinWidth: this.props.dialogMinWidth,
      dialogWidth: this.props.dialogWidth,
      disableAutoFocus: this.props.disableAutoFocus,
      initialPosition,
      // transparent by default to match Desktop behavior.
      isGlassTransparent: true,
      isModal: this.props.isModal,
      onCloseRequest: this.props.onCloseRequest,
      positioningBehavior: widgets.DialogPositioningBehavior.Draggable,
      shouldAdjustPositionOnWindowResize: true,
      showCloseButton: !this.props.hideCloseButton,
      showFooter: false,
      type:
        this.props.showTitleBar || this.props.showTitleBar === undefined
          ? widgets.DialogType.NormalWithTitleBar
          : widgets.DialogType.NormalWithoutTitleBar,
      testId: this.props.testId,
      title: this.props.title,
      userResizeMode,
      zIndex: 988,
    };
    return <widgets.DialogWidget {...dialogProps} />;
  }
}
